// ConsultaTrackingCH.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/Layout';
import { AuthUser } from '../../../components/AuthUser';
import { Searchbar } from '../../../components/Searchbar';
import { getTrackingxVendedor } from '../../../api/requestTracking';
import { getChxpressGuias } from '../../../api/requestTrackingCHexpress';
import Pagination from 'react-responsive-pagination';
import { Dropdown, DropdownButton, Modal, Button } from 'react-bootstrap';
import { DateRangePicker, Stack } from 'rsuite';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';

export const ConsultaTrackingCH = () => {
  const { user, getToken } = AuthUser();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [loadingChxpress, setLoadingChxpress] = useState(false);
  const [errorChxpress, setErrorChxpress] = useState(null);

  const [searchbarDoc, setSearchbarDoc] = useState('d-none');
  const [searchbarCli, setSearchbarCli] = useState('d-none');
  const [searchDate, setSearchDate] = useState('d-none');

  const [notFound, setNotFound] = useState(false);
  const [searching, setSearching] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  // Datos
  const [Tracking, setTracking] = useState([]); // fallback local
  const [chxpressGuias, setChxpressGuias] = useState([]); // datos CHxpress
  const [chxpressLoaded, setChxpressLoaded] = useState(false);

  // Mobile detail modal
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [selectedGuia, setSelectedGuia] = useState(null);

  const predefinedRanges = [
    {
      label: 'Últimos 3 meses',
      value: [startOfMonth(addMonths(new Date(), -3)), endOfMonth(addMonths(new Date(), -1))],
      placement: 'bottom'
    },
    {
      label: 'Últimos 6 meses',
      value: [startOfMonth(addMonths(new Date(), -6)), endOfMonth(addMonths(new Date(), -1))],
      placement: 'bottom'
    },
    {
      label: 'Último año',
      value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
      placement: 'bottom'
    }
  ];

  useEffect(() => {
    if (user) loadTracking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const loadTracking = async () => {
    setLoading(true);
    setChxpressLoaded(false);
    try {
      const resp = await getChxpressGuias({ codVendedor: user?.CodVendedor ?? '' });
      const guias = (resp && resp.data) ? resp.data : [];
      setChxpressGuias(guias);
      setTracking([]);
      setPage(1);
      setTotalPages(1);
    } catch (err) {
      console.error('Error loadTracking (CHxpress):', err);
      setChxpressGuias([]);
    } finally {
      setLoading(false);
      setChxpressLoaded(true);
    }
  };

  // loadData: intenta obtener guías CHxpress filtradas por vendedor,
  // si no hay resultados, fallback al tracking viejo
  const loadData = async () => {
    setLoading(true);
    setChxpressLoaded(false);
    setErrorChxpress(null);
    try {
      setLoadingChxpress(true);
      const res = await getChxpressGuias({ codVendedor: user?.CodVendedor ?? '' });
      console.log('Respuesta CHxpress API:', res);
      const data = (res && res.data) ? res.data : [];
      if (data && data.length > 0) {
        const sorted = [...data].sort((a, b) => {
          const fa = (a.factura_guia ?? '').localeCompare(b.factura_guia ?? '');
          if (fa !== 0) return fa;
          const ca = (a.destinatario_nombre ?? '').localeCompare(b.destinatario_nombre ?? '');
          if (ca !== 0) return ca;
          const da = a.fecha_salida ? new Date(a.fecha_salida) : new Date(0);
          const db = b.fecha_salida ? new Date(b.fecha_salida) : new Date(0);
          return db - da;
        });
        setChxpressGuias(sorted);
        setTracking([]);
        setPage(1);
        setTotalPages(1);
      } else {
        const res2 = await getTrackingxVendedor(user?.CodVendedor ?? 'none');
        if (res2 && res2.data) {
          setTracking(res2.data);
          setPage(res2.meta?.current_page ?? 1);
          setTotalPages(res2.meta?.last_page ?? 1);
        } else {
          setTracking(Array.isArray(res2) ? res2 : []);
        }
      }
    } catch (err) {
      console.error('Error loadData CHxpress:', err);
      setErrorChxpress(err);
      try {
        const res2 = await getTrackingxVendedor(user?.CodVendedor ?? 'none');
        if (res2 && res2.data) {
          setTracking(res2.data);
          setPage(res2.meta?.current_page ?? 1);
          setTotalPages(res2.meta?.last_page ?? 1);
        } else {
          setTracking(Array.isArray(res2) ? res2 : []);
        }
      } catch (err2) {
        console.error('Error fallback tracking:', err2);
      }
    } finally {
      setChxpressLoaded(true);
      setLoading(false);
      setLoadingChxpress(false);
    }
  };

  // onSearch
  const onSearch = async (busqueda) => {
    // Por cliente
    if (searchbarCli === 'd-block') {
      if (!busqueda) {
        return loadTracking();
      }
      setLoading(true);
      setNotFound(false);
      setSearching(true);
      try {
        const resp = await getChxpressGuias({ codVendedor: user.CodVendedor, cliente: busqueda });
        const data = (resp && resp.data) ? resp.data : [];
        if (!data || data.length === 0) {
          setNotFound(true);
          setTracking([]);
        } else {
          setChxpressGuias(data);
          setPage(1);
          setTotalPages(1);
        }
      } catch (err) {
        console.error('Error search by cliente:', err);
        setNotFound(true);
        setTracking([]);
      } finally {
        setLoading(false);
        setSearching(false);
      }

    // Por factura
    } else if (searchbarDoc === 'd-block') {
      if (!busqueda) {
        return loadTracking();
      }
      setLoading(true);
      setNotFound(false);
      setSearching(true);
      try {
        const resp = await getChxpressGuias({ codVendedor: user.CodVendedor, factura: busqueda });
        const data = (resp && resp.data) ? resp.data : [];
        if (!data || data.length === 0) {
          setNotFound(true);
          setTracking([]);
        } else {
          setChxpressGuias(data);
          setPage(1);
          setTotalPages(1);
        }
      } catch (err) {
        console.error('Error search by factura:', err);
        setNotFound(true);
        setTracking([]);
      } finally {
        setLoading(false);
        setSearching(false);
      }
    } else {
      await loadTracking();
    }
  };

  const loadPage = async (pageData) => {
    await loadTracking();
  };

  const handlePageChange = async (p) => {
    setCurrentPage(p);
    loadPage(p);
  };

  // formatea fecha para mostrar
  function formatFechaMostrar(fechaString) {
    if (!fechaString) return '0000-00-00 00:00:00';
    try {
      const d = new Date(fechaString);
      if (isNaN(d.getTime())) return fechaString;
      return d.toLocaleString('es-VE');
    } catch (e) {
      return fechaString;
    }
  }

  // Genera el elemento de estado (círculo + texto)
  function estadoElementoFromGuia(g) {
    const salida = g?.fecha_salida ?? null;
    const entrega = g?.fecha_entrega ?? null;
    if (salida && !entrega) {
      return (<span><span style={{fontSize:'18px'}}>🔵</span> En proceso de llegada</span>);
    } else if (salida && entrega) {
      return (<span><span style={{fontSize:'18px'}}>🟢</span> Entregado {formatFechaMostrar(entrega)}</span>);
    } else {
      return (<span><span style={{fontSize:'18px'}}>🔴</span> No ha llegado a CH</span>);
    }
  }

  // Render de una fila de CHxpress (desktop)
  const renderChxpressRow = (g, idx) => {
    return (
      <tr key={`chx-${idx}`}>
        <td className='text-danger fw-bold text-center'>{g.factura_guia}</td>
        <td>{g.destinatario_nombre}</td>
        <td className='text-center'>{g.fecha_salida ? formatFechaMostrar(g.fecha_salida) : '0000-00-00 00:00:00'}</td>
        <td>{estadoElementoFromGuia(g)}</td>
      </tr>
    );
  };

  // Mobile: abre modal con detalle de la guía seleccionada
  const openMobileDetail = (guia) => {
    setSelectedGuia(guia);
    setShowMobileModal(true);
  };

  const closeMobileDetail = () => {
    setSelectedGuia(null);
    setShowMobileModal(false);
  };

  return (
    <Layout>
      {loading ? (
        <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
          <span className="loader-tracking"></span>
        </div>
      ) : (
        <>
          <div className="consultas-title pt-5">
            <h4 className='bg-belmeny text-light px-5 rounded-pill'>Tracking de Pedidos Chxpress</h4>
          </div>

          <h6 className="text-center mt-2 mb-4 text-belmeny"><i>Vendedor - {user.Nombre} - {user.CodVendedor}</i></h6>

          {/* DESKTOP */}
          <div className="container-fluid d-md-block d-none mb-3">
            <div className="row">
              <div className="col">
                <div className="mb-2">
                 {/* <DropdownButton key={'end'} id={`dropdown-button-drop-${'end'}`} drop={'end'} variant="primary" title={` Filtros `}>
                    <Dropdown.Item eventKey="1" className='text-decoration-none' onClick={e =>*/} {/* showFilter */} {/*}>Por Factura</Dropdown.Item>
                    <Dropdown.Item eventKey="2" className='text-decoration-none' onClick={e => */} {/* showFilter */} {/*}>Por cliente</Dropdown.Item>
                    <Dropdown.Item eventKey="3" className='text-decoration-none' onClick={e => */} {/* showFilter */} {/*}>Por fecha</Dropdown.Item>
                    <Dropdown.Divider />*/}
                    {/*<Dropdown.Item eventKey="4" className='bg-danger text-light text-decoration-none' onClick={e => */} {/* showFilter limpiar */} {/*}>Limpiar filtros</Dropdown.Item>
                  </DropdownButton>*/}
                </div>
                <div className={searchbarDoc}><Searchbar onSearch={onSearch} /></div>
                <div className={searchbarCli}><Searchbar onSearch={onSearch} /></div>
                <Stack direction="row" spacing={10} alignItems="flex-start" className={searchDate}>
                  <DateRangePicker appearance={"subtle"} ranges={predefinedRanges} placeholder="Buscar por fecha" style={{ width: 300 }} onChange={e => {}} className="border rounded-pill mb-2" showOneCalendar />
                </Stack>
              </div>
            </div>

            <div className="rounded-0 my-2">
              <table className='table table-bordered table-hover border-belmeny'>
                <thead className='bg-belmeny text-light text-center'>
                  <tr>
                    <th>Factura</th>
                    <th className='w-50'>Cliente</th>
                    <th>Fecha de Salida</th>
                    <th>Fecha de Entrega al Cliente</th>
                  </tr>
                </thead>
                <tbody>
                  { chxpressLoaded && chxpressGuias && chxpressGuias.length > 0 ? (
                      chxpressGuias.map((g, idx) => renderChxpressRow(g, idx))
                    ) : (
                      chxpressLoaded ? (
                        Tracking && Tracking.length > 0 ? (
                          Tracking.map((item) => (
                            <tr key={`t-${item.Documento}`}>
                              <td className='text-danger fw-bold text-center'>{item.Factura ?? item.Documento}</td>
                              <td>{item.NombreCliente}</td>
                              <td className='text-center'>{item.FechaSalida ? new Date(item.FechaSalida).toLocaleString('es-VE') : '0000-00-00 00:00:00'}</td>
                              <td>{(item.FechaAnulacion === "0000-00-00 00:00:00") ? <>🔵 No Anulado</> : <>🔴 ANULADO</>}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="4" className="text-center">No hay guías CHxpress para este vendedor.</td></tr>
                        )
                      ) : (
                        <tr><td colSpan="4" className="text-center">Cargando guías CHxpress...</td></tr>
                      )
                    )
                  }
                </tbody>
              </table>
            </div>

            <Pagination total={totalPages} current={currentPage} onPageChange={page => handlePageChange(page)} />
          </div>

          {/* MOBILE: list of cards */}
          <div className="container-fluid d-block d-md-none mb-3">
            { chxpressLoaded && chxpressGuias && chxpressGuias.length > 0 ? (
              chxpressGuias.map((g, idx) => (
                <div className="card my-2 drop-shadow border-belmeny" key={`m-${idx}`}>
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-1 text-belmeny fw-bold">Factura: {g.factura_guia}</h6>
                        <p className="mb-1"><strong>{g.destinatario_nombre}</strong></p>
                        <p className="mb-1 small text-muted">Salida: {g.fecha_salida ? formatFechaMostrar(g.fecha_salida) : 'Sin info'}</p>
                        <p className="mb-0 small">{estadoElementoFromGuia(g)}</p>
                      </div>
                      <div className="d-flex align-items-start">
                        <div>
                          <Button variant="outline-primary" size="sm" onClick={() => openMobileDetail(g)}>Ver detalles</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              chxpressLoaded ? (
                Tracking && Tracking.length > 0 ? (
                  Tracking.map((item) => (
                    <div className="card my-2 drop-shadow border-belmeny" key={`mt-${item.Documento}`}>
                      <div className="card-body">
                        <div className="d-flex justify-content-between">
                          <div>
                            <h6 className="mb-1 text-belmeny fw-bold">Factura: {item.Factura ?? item.Documento}</h6>
                            <p className="mb-1"><strong>{item.NombreCliente}</strong></p>
                            <p className="mb-1 small text-muted">Salida: {item.FechaSalida ? new Date(item.FechaSalida).toLocaleString('es-VE') : 'Sin info'}</p>
                            <p className="mb-0 small">{(item.FechaAnulacion === "0000-00-00 00:00:00") ? <>🔵 No Anulado</> : <>🔴 ANULADO</>}</p>
                          </div>
                          <div className="d-flex align-items-start">
                            <div>
                              <Button variant="outline-primary" size="sm" onClick={() => {
                                // construir un objeto similar a guía para mostrar en modal
                                openMobileDetail({
                                  factura_guia: item.Factura ?? item.Documento,
                                  destinatario_nombre: item.NombreCliente,
                                  fecha_salida: item.FechaSalida || null,
                                  fecha_entrega: null
                                });
                              }}>Ver detalles</Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center my-3">No hay guías CHxpress para este vendedor.</div>
                )
              ) : (
                <div className="text-center my-3">Cargando guías CHxpress...</div>
              )
            )}
          </div>

          {/* Mobile detail modal (compact) */}
          <Modal show={showMobileModal} onHide={closeMobileDetail} centered>
            <Modal.Header className="bg-belmeny text-light">
              <Modal.Title>Detalle guía</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedGuia ? (
                <>
                  <p><strong>Factura:</strong> {selectedGuia.factura_guia}</p>
                  <p><strong>Cliente:</strong> {selectedGuia.destinatario_nombre}</p>
                  <p><strong>Fecha salida:</strong> {selectedGuia.fecha_salida ? formatFechaMostrar(selectedGuia.fecha_salida) : 'Sin información'}</p>
                  <p><strong>Fecha entrega:</strong> {selectedGuia.fecha_entrega ? formatFechaMostrar(selectedGuia.fecha_entrega) : 'Sin información'}</p>
                  <p><strong>Estatus:</strong> {estadoElementoFromGuia(selectedGuia)}</p>
                  {selectedGuia.numero_guia && <p><strong>Número guía:</strong> {selectedGuia.numero_guia}</p>}
                  {selectedGuia.nro_viaje && <p><strong>Viaje:</strong> {selectedGuia.nro_viaje}</p>}
                  {selectedGuia.estado && <p><strong>Estado:</strong> {selectedGuia.estado} - {selectedGuia.ciudad ?? ''}</p>}
                </>
              ) : (
                <p>No hay información.</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeMobileDetail}>Cerrar</Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Layout>
  );
};
